// extracted by mini-css-extract-plugin
export default {"container":"Search_container__+MxE5","searchFormWrapper":"Search_searchFormWrapper__sqcH5"};